import React from 'react';
import LeftSide from "../../Component/LeftSide";
import RightSide from "../../Component/RightSide";
import Section from "../../Component/Section";
const Dashboard = () => {
    return (
        <React.Fragment>
      <div className='top_section m-0 uppermost-right'>
      <LeftSide/>          
        <RightSide/>
          
      </div>
      <Section/>
    </React.Fragment>
    )
}

export default Dashboard;